export function calculateSubtotal(decimalValue, rate) {
  const value = parseFloat(decimalValue) || 0;
  const unitRate = parseFloat(rate) || 0;

  const subtotal = value * unitRate;

  // Format as USD currency string
  return subtotal.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}